import FuxHTTP from "../lib/FuxFramework/FuxHTTP";
import OrdiniAPI from "./OrdiniAPI";
import APIConfig from "./APIConfig";
import AuthAPI from "./AuthAPI";
import AppConfig from "../config/AppConfig";
import {NegozioOpenStore} from "../stores/NegozioOpenStore";


var CouponAPI = {
    getValiditaCouponPerUtente: function (codice_coupon, type, importo_speso = null, data_utilizzo = null, cart = null) {

        const body = {
            id_negozio: NegozioOpenStore.id_negozio,
            codice_coupon: codice_coupon,
            type: type,
        };
        if (importo_speso !== null) body.importo_speso = importo_speso;
        if (cart !== null) body.carrello = JSON.stringify(cart);
        if (data_utilizzo) body.data_utilizzo = data_utilizzo;

        if (cart !== null) {
            return FuxHTTP.apiPostRequestWithPromise(
                APIConfig.url(`/coupon/verificaCoupon/${AuthAPI.currentUser.accessToken}`), body,
                FuxHTTP.RESOLVE_DATA, FuxHTTP.REJECT_MESSAGE
            );
        }
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url(`/coupon/verificaCoupon/${AuthAPI.currentUser.accessToken}?` + new URLSearchParams(body)), {},
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    }
}

export default CouponAPI;
